module.exports = __webpack_public_path__ + "static/media/winking-face-with-tongue-svgrepo-com.4b744cd4.svg";